module.exports = __webpack_public_path__ + "static/media/jbc.6e5831aa.png";